module.exports = __webpack_public_path__ + "static/img/AO.7877bd09.png";